import { useState } from "react";
import {
  Box,
  IconButton,
  Typography,
  Menu,
  MenuItem,
  useTheme,
  Fade,
  Divider,
} from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import DeleteOutlinedIcon from "@mui/icons-material/DeleteOutlined";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import HistoryOutlinedIcon from "@mui/icons-material/HistoryOutlined";
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";

const ActionMenu = ({
  params,
  colors,
  handleEditProduct,
  handleOpenDialog,
  handleOpenRestock,
  handleOpenHistory,
  handleOpenThreshold,
}) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const theme = useTheme();

  const open = Boolean(anchorEl);

  const handleClick = (event) => setAnchorEl(event.currentTarget);
  const handleClose = () => setAnchorEl(null);

  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      width="100%"
      height="100%"
    >
      <IconButton
        onClick={handleClick}
        sx={{
          color: colors.gray[100],
          transition: "transform 0.15s ease",
          "&:active": { transform: "scale(0.9)" },
        }}
        aria-controls={open ? "action-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
      >
        <MoreVertIcon />
      </IconButton>

      <Menu
        id="action-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        TransitionComponent={Fade}
        transitionDuration={300}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
        slotProps={{
          backdrop: {
            sx: {
              backdropFilter: "blur(3px)",
              backgroundColor: "rgba(0,0,0,0.1)",
            },
          },
        }}
        PaperProps={{
          sx: {
            backgroundColor:
              theme.palette.mode === "dark"
                ? `rgba(${parseInt(colors.primary[400].slice(1, 3), 16)}, ${parseInt(colors.primary[400].slice(3, 5), 16)}, ${parseInt(colors.primary[400].slice(5, 7), 16)}, 0.8)`
                : "rgba(255, 255, 255, 0.95)",
            backdropFilter: "blur(16px)",
            border: `1px solid ${theme.palette.mode === "dark" ? "rgba(255, 255, 255, 0.15)" : "rgba(0, 0, 0, 0.1)"}`,
            boxShadow:
              theme.palette.mode === "dark"
                ? "0 8px 32px 0 rgba(0, 0, 0, 0.4)"
                : "0 8px 32px 0 rgba(0, 0, 0, 0.15)",
            borderRadius: "12px",
            minWidth: "150px",
            mt: 1,
            "& .MuiMenuItem-root": {
              padding: "12px 20px",
              gap: "12px",
              margin: "4px 8px",
              borderRadius: "8px",
              transition: "all 0.2s ease-in-out",
              color: `${colors.gray[100]} !important`,
              fontWeight: 600,
              fontSize: "14px",
              "&:hover": {
                backgroundColor:
                  theme.palette.mode === "dark"
                    ? "rgba(255, 255, 255, 0.1) !important"
                    : "rgba(0, 0, 0, 0.04) !important",
              },
              "&:active": { transform: "scale(0.95)" },
              "&.delete-menu-item": {
                color: `${colors.redAccent[500]} !important`,
                "&:hover": {
                  backgroundColor:
                    theme.palette.mode === "dark"
                      ? "rgba(244, 63, 94, 0.15) !important"
                      : "rgba(225, 29, 72, 0.1) !important",
                },
              },
            },
            "& .MuiDivider-root": {
              margin: "4px 8px",
              borderColor:
                theme.palette.mode === "dark"
                  ? "rgba(255, 255, 255, 0.1)"
                  : "rgba(0, 0, 0, 0.1)",
            },
          },
        }}
      >
        <MenuItem
          onClick={() => {
            handleEditProduct(params.row);
            handleClose();
          }}
        >
          <EditOutlinedIcon fontSize="small" />
          <Typography fontSize="14px" fontWeight="600">
            Edit
          </Typography>
        </MenuItem>

        <MenuItem
          onClick={() => {
            if (typeof handleOpenRestock === "function") {
              handleOpenRestock(params.row);
            }
            handleClose();
          }}
        >
          <AddCircleOutlineIcon fontSize="small" />
          <Typography fontSize="14px" fontWeight="600">
            Restock
          </Typography>
        </MenuItem>

        <MenuItem
          onClick={() => {
            if (typeof handleOpenHistory === "function") {
              handleOpenHistory(params.row);
            }
            handleClose();
          }}
        >
          <HistoryOutlinedIcon fontSize="small" />
          <Typography fontSize="14px" fontWeight="600">
            Update History
          </Typography>
        </MenuItem>

        <MenuItem
          onClick={() => {
            if (typeof handleOpenThreshold === "function") {
              handleOpenThreshold(params.row);
            }
            handleClose();
          }}
        >
          <SettingsOutlinedIcon fontSize="small" />
          <Typography fontSize="14px" fontWeight="600">
            Set Threshold
          </Typography>
        </MenuItem>

        <Divider />

        <MenuItem
          className="delete-menu-item"
          onClick={() => {
            handleOpenDialog(params.row.id);
            handleClose();
          }}
        >
          <DeleteOutlinedIcon fontSize="small" />
          <Typography fontSize="14px" fontWeight="600">
            Delete
          </Typography>
        </MenuItem>
      </Menu>
    </Box>
  );
};

export default ActionMenu;
